import { render } from "./ExtranetCorporate.vue?vue&type=template&id=4ccb5c0a&scoped=true"
import script from "./ExtranetCorporate.vue?vue&type=script&lang=js"
export * from "./ExtranetCorporate.vue?vue&type=script&lang=js"

import "./ExtranetCorporate.vue?vue&type=style&index=0&id=4ccb5c0a&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccb5c0a"]])

export default __exports__